export const COLLAPSE_ALL = "COLLAPSE_ALL";
export const EXPAND_ALL = "EXPAND_ALL";
export const COLLAPSE_COLLAPSE = "COLLAPSE_COLLAPSE";
export const EXPAND_COLLAPSE = "EXPAND_COLLAPSE";
export const HIDE_COLLAPSE = "HIDE_COLLAPSE";
export const SHOW_ALL = "SHOW_ALL";
